// extracted by mini-css-extract-plugin
export var dot = "_qp-2";
export var wave = "_qp-0";
export var waveSmall = "_qp-1";